<template>
<div :style="themePageStyle">
  <div class="container" style="padding-top:24px;padding-bottom:100px;max-width:900px;">
    <div class="d-flex align-items-center mb-3">
      <button class="btn btn-sm btn-outline-secondary me-2" @click="$router.go(-1)"><i class="mdi mdi-arrow-left me-1"></i>Back</button>
      <h5 class="mb-0 fw-bold" :style="{color:darkMode?'#F5F0E8':'#1A1A1A'}"><i class="mdi mdi-file-document me-2" style="color:#BFA164;"></i>Bills received</h5>
    </div>

    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!bills.length" class="text-center py-5">
      <i class="mdi mdi-file-document-outline" style="font-size:48px;color:#BFA164;opacity:.5;"></i>
      <p class="mt-2 mb-1" :style="{color:darkMode?'#F5F0E8':'#1A1A1A'}">No bills yet</p>
      <p class="mb-0" style="font-size:13px;color:#6B6356;">When a seller sends you a bill, it'll appear here — tap to review and pay via M-Pesa.</p>
    </div>

    <div v-else>
      <div v-for="b in bills" :key="b.id" class="bi-card" @click="$router.push('/bills/' + b.public_token)">
        <div class="bi-avatar">
          <img v-if="b.seller_avatar" :src="photoUrl(b.seller_avatar)" alt="" />
          <span v-else>{{ (b.seller_name || '?').charAt(0).toUpperCase() }}</span>
        </div>
        <div class="flex-fill" style="min-width:0;">
          <div style="font-weight:700;font-size:14px;">{{ b.seller_name || 'Seller' }}</div>
          <div style="font-family:'Courier New',monospace;font-size:11px;color:#BFA164;">{{ b.bill_number }}</div>
          <div style="font-size:11px;color:#6B6356;">
            <i class="mdi mdi-clock-outline"></i> {{ formatDate(b.created_at) }}
            <span v-if="b.status === 'sent' && b.expires_at"> · valid until {{ formatDate(b.expires_at) }}</span>
          </div>
        </div>
        <div class="text-end">
          <div style="font-weight:800;color:#BFA164;">{{ b.currency }} {{ fNum(b.total) }}</div>
          <span class="bi-status" :class="'bi-status-'+b.status">{{ b.status }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from '@/api';
export default {
  name: 'BillsInbox',
  data(){
    return {
      darkMode: (document.documentElement.getAttribute('data-theme') === 'dark'),
      loading: true,
      bills: []
    };
  },
  computed: {
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){ this.load(); },
  methods: {
    async load(){
      this.loading = true;
      try {
        var r = await executeJson({ function: 'getBillsForMe', buyerId: sessionStorage.getItem('userId') || '' }, flocker);
        if (r.data && r.data.success) this.bills = r.data.data.bills || [];
      } catch(e){}
      this.loading = false;
    },
    fNum(n){ return Number(n || 0).toLocaleString('en-KE', { maximumFractionDigits: 2 }); },
    formatDate(d){ if (!d) return ''; return new Date(String(d).replace(' ','T')).toLocaleDateString('en-KE', { day:'numeric', month:'short' }); },
    photoUrl(p){ if(!p) return ''; if(p.startsWith('http')) return p; return uploads + String(p).replace(/^uploads\//,''); }
  }
};
</script>

<style scoped>
.bi-card { display:flex; align-items:center; gap:12px; background:#FFFFFF; border:1px solid #E8E2DA; border-radius:10px; padding:14px; margin-bottom:10px; cursor:pointer; transition:all .15s; }
.bi-card:hover { border-color:#BFA164; transform:translateY(-1px); }
html[data-theme="dark"] .bi-card { background:#141414; border-color:#1E1E1E; color:#F5F0E8; }
.bi-avatar { width:44px; height:44px; border-radius:50%; background:#BFA164; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; flex-shrink:0; overflow:hidden; }
.bi-avatar img { width:100%; height:100%; object-fit:cover; }
.bi-status { display:inline-block; padding:2px 8px; border-radius:8px; font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.4px; margin-top:2px; }
.bi-status-sent { background:rgba(255,171,0,.15); color:#FFAB00; }
.bi-status-accepted { background:rgba(79,195,247,.15); color:#4FC3F7; }
.bi-status-paid { background:rgba(80,200,120,.15); color:#50C878; }
.bi-status-countered { background:rgba(206,147,216,.15); color:#CE93D8; }
</style>
